import ApiService from './ApiService'
import { useUserStore } from '../stores/user.js'

const UserService = {
    async fetchUser() {
        const userStore = useUserStore()
        const userType = userStore.getUserType
        const route = ApiService.getRouteForUserType('profile.show', userType)

        const response = await ApiService.get(route)
        if (!response || !response.data) return null

        const userData = response.data
        const { user_address } = userData

        const processedUser = {
            ...(user_address && user_address[0] ? user_address[0] : {}),
            ...userData,
        }

        delete processedUser.user_address

        if (processedUser.preferred_locale) {
            processedUser.preferred_locale =
                processedUser.preferred_locale === 'de' ||
                processedUser.preferred_locale === 'de-DE'
                    ? 'de-DE'
                    : processedUser.preferred_locale
        }

        return processedUser
    },

    saveUser(userData) {
        const userStore = useUserStore()
        const userType = userStore.getUserType
        const route = ApiService.getRouteForUserType('profile.update', userType)

        const locale =
            userData.preferred_locale.value === undefined
                ? userData.preferred_locale
                : userData.preferred_locale.value

        const data = {
            address: null,
            ...userData,
            locale,
        }
        delete data.preferred_locale
        delete data.permissions
        delete data.home

        return ApiService.post(route, data)
    },

    async fetchDigitalId() {
        const response = await ApiService.get('permission.permission_by_category')
        if (!response || !response.data) return null
        return response.data
    },

    async updatePassword(data) {
        await ApiService.post('auth.change_password', data)
    },

    switchOem(oem) {
        return ApiService.get('operations.switch_oem', { oem })
    },
}

export default UserService
